import { render, staticRenderFns } from "./EditConnection.vue?vue&type=template&id=66c64780&"
import script from "./EditConnection.vue?vue&type=script&lang=js&"
export * from "./EditConnection.vue?vue&type=script&lang=js&"
import style0 from "./EditConnection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports